import { render } from "./SeccionTextoIndex.vue?vue&type=template&id=4dcc15ec&scoped=true"
import script from "./SeccionTextoIndex.vue?vue&type=script&lang=js"
export * from "./SeccionTextoIndex.vue?vue&type=script&lang=js"

import "./SeccionTextoIndex.vue?vue&type=style&index=0&id=4dcc15ec&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcc15ec"]])

export default __exports__